import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "horizontal",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    alignItems: "flex-start"
  }
}))

export const StyledSortBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}))
